import React, { useState, useCallback, useEffect } from "react";
import styled, { keyframes } from "styled-components";

const Book = ({ sidebarItems,
  infiniteItems,

  onComplete, 
  
  // Cover info
  
 cover = {
  heading: "Thesis Research Hub",
  tagline: "Advancing Knowledge Through Scholarly Exploration",
  // note: "Click or wait for auto-flip",
},
  // Research pages
  pages = [
    {
      subtitle: "Chapter 1",
      title: "Introdcution ",
      content:
        "Introduces the research problem and sets the stage for the study.",
      bullets: ["Systematic literature review", "Case study analysis", "Statistical modeling"],
      priceHint: "Published: Journal of Advanced Research, 2023",
      cta: "Read Publication",
    },
    {
      subtitle: "Chapter 1",
      title: "Introduction ",
      content:
        "Introduces the research problem and sets the stage for the study.",
      bullets: ["Background and context", "Research problem / question", "Objectives and scope",
        "Significance of study","Significance of study","Thesis structure"
      ],
      






      // priceHint: "Dataset: n=1,247 participants",
      // cta: "View Methodology",
    },
    {
      subtitle: "Chapter 2",
      title: "Litrature Review",
      content:
        "Reviews existing research to identify gaps and position your work.",
      bullets: ["Summary of prior studies", "Key theories and debates", "Research gaps",'Relevance to your study'],
      // priceHint: "Cited 84 times",
      // cta: "Explore Framework",
    },
   {
"subtitle": "Chapter 3",
"title": "Research Methodology",
"content": "Explains how the research was designed and carried out.",
"bullets": [
"Research design (qualitative/quantitative)",

"Data collection methods",

"Data analysis techniques",

"Justification of methods",

"Limitations"
],},
    {
"subtitle": "Chapter 4",
"title": "Results / Findings",
"content": "Presents the data and outcomes of the research.",
"bullets": [
"Organized presentation of results",

"Tables, graphs, visuals",

"Key patterns and trends",

"Main outcomes"
],
},
   {
"subtitle": "Chapter 5",
"title": "Conclusion",
"content": "Summarizes the research and highlights its contributions.",
"bullets": [
"Recap of key findings",
"Contribution to knowledge","Recommendations for future research",


],
}
  ],
  autoFlipDelay = 5000, // Increased to 5 seconds for research content
  enableAutoFlip = true,
}) => {
  const [flippedCount, setFlippedCount] = useState(0);
  const [isAutoFlipping, setIsAutoFlipping] = useState(enableAutoFlip);
  const [isPaused, setIsPaused] = useState(false);
  const total = pages.length;

  const next = useCallback(() => {
    setFlippedCount((c) => {
      const nextCount = c + 1;
      if (nextCount > total && isAutoFlipping) {
        return 0; // loop in auto-flip
      }
      return Math.min(nextCount, total);
    });
  }, [total, isAutoFlipping]);
useEffect(() => {
  if (flippedCount === pages.length) {
    if (typeof onComplete === "function") {
      onComplete();
    }
  }
}, [flippedCount, pages.length, onComplete]);
  const prev = useCallback(() => {
    setFlippedCount((c) => Math.max(c - 1, 0));
  }, []);

  const toggleAutoFlip = useCallback(() => {
    setIsAutoFlipping((prev) => !prev);
  }, []);

  // Auto-flip
  useEffect(() => {
    if (!isAutoFlipping || isPaused) return;
    const interval = setInterval(() => {
      next();
    }, autoFlipDelay);
    return () => clearInterval(interval);
  }, [next, autoFlipDelay, isAutoFlipping, isPaused]);

  // Pause on hover
  const handleMouseEnter = useCallback(() => setIsPaused(true), []);
  const handleMouseLeave = useCallback(() => setIsPaused(false), []);

  // Keyboard controls
  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
      if (e.key === " ") {
        e.preventDefault();
        toggleAutoFlip();
      }
    },
    [next, prev, toggleAutoFlip]
  );

  const handleManualClick = useCallback(
    (clickNext) => {
      setIsPaused(true);
      if (clickNext) next();
      setTimeout(() => setIsPaused(false), autoFlipDelay / 2);
    },
    [next, autoFlipDelay]
  );

  return (
    
    <StyledWrapper>
      <div
        className="book"
        role="button"
        tabIndex={0}
        onKeyDown={onKeyDown}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        aria-label="Interactive research flip book"
      >
        <div className="content" aria-hidden>
          <div className="hint">
            {isAutoFlipping ? "Auto-flipping..." : "Click to flip →"}
          </div>
        </div>

        {/* COVER */}
        <div
          className={`cover leaf ${flippedCount > 0 ? "flipped" : ""}`}
          onClick={() => handleManualClick(true)}
          aria-hidden
        >
          <div className="cover-surface">
            <div className="cover-overlay">
              <div className="cover-content">
                <h2>{cover.heading}</h2>
                <p className="tagline">{cover.tagline}</p>
                <div className="decorative-line"></div>
                <p className="note">{cover.note}</p>
               <div className="cover-footer">
  <span>University Research Repository</span>
  <span>Thesis Edition 2025</span>
</div>

              </div>
            </div>
          </div>
        </div>

        {/* PAGES */}
        {pages.map((page, i) => {
          const z = 1000 - i - 1;
          const flipped = flippedCount > i;
          return (
            <div
              key={i}
              className={`leaf page ${flipped ? "flipped" : ""}`}
              style={{ zIndex: z }}
              onClick={flipped ? undefined : () => handleManualClick(true)}
              aria-hidden
            >
              <div className="page-surface">
                <div className="page-overlay">
                  <div className="page-info">
                    {page.subtitle && (
                      <span className="subtitle">{page.subtitle}</span>
                    )}
                    <h3 className="title">{page.title}</h3>
                    {page.content && (
                      <p className="content-text">{page.content}</p>
                    )}
                    {Array.isArray(page.bullets) && page.bullets.length > 0 && (
                      <ul className="bullets">
                        {page.bullets.map((b, idx) => (
                          <li key={idx}>{b}</li>
                        ))}
                      </ul>
                    )}
                    <div className="meta">
                      {page.priceHint && (
                        <span className="price">{page.priceHint}</span>
                      )}
                      {page.cta && <button className="cta">{page.cta}</button>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        {/* Controls */}
        <div className="controls">
          <button
            type="button"
            onClick={prev}
            disabled={flippedCount === 0}
            aria-label="Previous page"
          >
            ←
          </button>
          <span className="status">
            {flippedCount}/{total}
          </span>
          <button
            type="button"
            onClick={() => handleManualClick(true)}
            disabled={flippedCount === total}
            aria-label="Next page"
          >
            →
          </button>
          <button
            type="button"
            onClick={toggleAutoFlip}
            className={`auto-toggle ${isAutoFlipping ? "active" : ""}`}
            aria-label={isAutoFlipping ? "Disable auto-flip" : "Enable auto-flip"}
            title="Toggle auto-flip (Space key)"
          >
            {isAutoFlipping ? "⏸" : "▶"}
          </button>
        </div>

        {isAutoFlipping && !isPaused && (
          <div className="progress-indicator">
            <div
              className="progress-bar"
              style={{
                animationDuration: `${autoFlipDelay}ms`,
                animationIterationCount: "infinite",
              }}
            />
          </div>
        )}
      </div>
    </StyledWrapper>
  );
};

// Keyframes for animations


const progressAnimation = keyframes`
  from { transform: translateX(-100%); }
  to { transform: translateX(0); }
`;

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  background: linear-gradient(135deg, #f0f4f8 0%, #d9e2ec 100%);
  padding: 10px;
  @media (min-width: 640px) {
    padding: 20px;
  }
  font-family: 'Georgia', serif;

  .book {
    position: relative;
    width: 95vw;   
    height: 60vh; 
    max-width: 800px; 
    max-height: 500px; 
    border-radius: 16px;
    background: linear-gradient(145deg, #f5f5f5, #e6e6e6);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
    perspective: 1600px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333;
    padding: 20px;
    outline: none;
    margin: 20px auto;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .book:hover {
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2), 0 8px 20px rgba(0, 0, 0, 0.12);
  }

  .book, .content { transform-style: preserve-3d; }

  .content {
    position: absolute;
    inset: 0;
    border-radius: 14px;
    background: linear-gradient(135deg, #f8f9fc 0%, #e8edf5 100%);
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .hint {
    position: absolute;
    bottom: 15px;
    right: 20px;
    font-size: clamp(10px, 2vw, 12px);
    opacity: 0.7;
    user-select: none;
    color: #4a5568;
    font-weight: 500;
    font-style: italic;
  }

  /* Shared page surface */
  .cover-surface,
  .page-surface {
    position: relative;
    width: 100%;
    height: 100%;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    overflow: hidden;
  }

  .leaf {
    position: absolute;
    inset: 0;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1), 0 3px 10px rgba(0, 0, 0, 0.05);
    transform-origin: left center;
    transform-style: preserve-3d;
    will-change: transform;
    transition: transform 2s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 0.5s ease;
    backface-visibility: hidden;
    overflow: hidden;
    cursor: pointer;
  }

  .leaf::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    background: linear-gradient(90deg, rgba(0,0,0,0.08), rgba(0,0,0,0.01));
    opacity: 0;
    transition: opacity 0.4s ease;
    transform: translateZ(1px);
    border-radius: 14px;
  }

  .leaf:hover { 
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15), 0 5px 15px rgba(0, 0, 0, 0.08);
  }
  
  .leaf:hover::before, .leaf.flipped::before { 
    opacity: 1; 
  }

  .leaf.flipped { 
    transform: rotateY(-180deg); 
    cursor: default; 
  }

  .cover {
    background: linear-gradient(135deg, #2c3e50 0%, #1a2530 100%);
    z-index: 2000;
  }

  .cover-overlay,
  .page-overlay {
    position: absolute;
    inset: 0;
    padding: clamp(20px, 4vw, 32px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .cover-overlay {
    background: linear-gradient(135deg, rgba(44, 62, 80, 0.95) 0%, rgba(26, 37, 48, 0.95) 100%);
    color: #ffffff;
    gap: 12px;

    .cover-content {
      max-width: 85%;
    }

    h2 {
      font-size: clamp(24px, 5vw, 36px);
      margin: 0 0 12px 0;
      font-weight: 700;
      letter-spacing: 0.5px;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      font-family: 'Times New Roman', serif;
    }
    
    .tagline {
      font-size: clamp(16px, 3vw, 20px);
      opacity: 0.9;
      margin: 0 0 16px 0;
      font-weight: 400;
      font-style: italic;
    }
    
    .decorative-line {
      width: 80px;
      height: 2px;
      background: linear-gradient(90deg, transparent, #ffffff, transparent);
      margin: 12px auto;
    }
    
    .note {
      font-size: clamp(12px, 2.5vw, 14px);
      opacity: 0.8;
      margin-top: 20px;
      font-style: italic;
    }
    
    .cover-footer {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-top: 30px;
      font-size: 12px;
      opacity: 0.7;
    }
  }

  .page-overlay {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fc 100%);
    color: #2d3748;
  }

  .page-info {
    width: 100%;
    max-width: 85%;
    margin: 0 auto;
  }

  .subtitle {
    font-size: clamp(12px, 2.2vw, 14px);
    color: #2c3e50;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    display: block;
    margin-bottom: 10px;
    font-weight: 600;
  }

  .title {
    font-size: clamp(20px, 4vw, 26px);
    font-weight: 700;
    margin: 0 0 16px 0;
    line-height: 1.3;
    color: #2c3e50;
    font-family: 'Times New Roman', serif;
  }

  .content-text {
    font-size: clamp(14px, 2.5vw, 16px);
    line-height: 1.6;
    opacity: 0.9;
    margin: 0 auto 16px;
    color: #4a5568;
  }

  .bullets {
    text-align: left;
    margin: 16px auto 20px;
    padding-left: 24px;
    max-width: 90%;
  }
  
  .bullets li {
    font-size: clamp(13px, 2.5vw, 15px);
    margin: 8px 0;
    color: #4a5568;
    list-style: disc;
    line-height: 1.5;
  }

  .meta {
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    flex-wrap: wrap;
  }

  .price {
    font-size: clamp(12px, 2.5vw, 14px);
    background: #edf2f7;
    color: #2d3748;
    border: 1px solid #e2e8f0;
    padding: 6px 12px;
    border-radius: 20px;
    font-weight: 500;
    font-style: italic;
  }

  .cta {
    font-size: clamp(12px, 2.5vw, 14px);
    padding: 8px 16px;
    border-radius: 8px;
    border: none;
    background: #2c3e50;
    color: #fff;
    cursor: pointer;
    transition: all 0.2s ease;
    font-weight: 500;
    box-shadow: 0 2px 5px rgba(44, 62, 80, 0.3);
  }
  
  .cta:hover { 
    transform: translateY(-2px); 
    box-shadow: 0 4px 8px rgba(44, 62, 80, 0.4);
    background: #1a2530;
  }

  .controls {
    position: absolute;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    align-items: center;
    z-index: 3000;
    background: rgba(255, 255, 255, 0.9);
    padding: 8px 16px;
    border-radius: 30px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .controls button {
    padding: 6px 10px;
    font-size: clamp(12px, 2.5vw, 14px);
    border-radius: 50%;
    width: 38px;
    height: 38px;
    border: none;
    background: #2c3e50;
    color: #fff;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .controls button:hover:not([disabled]) { 
    background: #1a2530; 
    transform: translateY(-1px); 
  }
  
  .controls button[disabled] { 
    opacity: 0.5; 
    cursor: not-allowed; 
  }

  .auto-toggle { 
    min-width: 38px;
    border-radius: 50%;
  }
  
  .auto-toggle.active { 
    background: #1a2530 !important; 
  }

  .status {
    color: #4a5568;
    font-size: clamp(12px, 2.5vw, 14px);
    min-width: 40px;
    text-align: center;
    font-weight: 500;
  }

  .progress-indicator {
    position: absolute;
    bottom: 0; 
    left: 0; 
    right: 0;
    height: 4px;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 0 0 14px 14px;
    overflow: hidden;
    z-index: 3001;
  }
  
  .progress-bar {
    height: 100%; 
    width: 100%;
    background: linear-gradient(90deg, #2c3e50, #1a2530);
    transform: translateX(-100%);
    animation: ${progressAnimation} linear infinite;
    border-radius: 0 0 14px 14px;
  }

  /* Responsive tweaks */
  @media (max-width: 768px) {
    .book { 
      width: 92vw; 
      height: 65vh; 
      min-height: 320px; 
    }
    
    .controls {
      bottom: 10px;
      padding: 6px 12px;
    }
    
    .controls button {
      width: 34px;
      height: 34px;
      padding: 4px 8px;
    }
  }
  
  @media (max-width: 480px) {
    .book { 
      width: 96vw; 
      height: 60vh; 
      min-height: 300px; 
      padding: 12px;
    }
    
    .cover-overlay,
    .page-overlay {
      padding: 16px;
    }
    
    .page-info {
      max-width: 95%;
    }
    
    .meta {
      flex-direction: column;
      gap: 10px;
    }
    
    .cover-footer {
      flex-direction: column;
      gap: 5px;
      text-align: center;
    }
  }
`;

export default Book;